<template>
  <vue-select
    :name="name"
    :class="wrapperClass()"
    :placeholder="placeholder"
    :label="label"
    :options="options"
    v-model="internalValue"
    :reduce='reduce'
    :v-validate="vValidate"
    :disabled="disabled"
    :select-on-tab="true"
    :getOptionLabel="getOptionLabel"
    :multiple="multiple"
  />
</template>
<script>
import VueSelect from 'vue-select'
export default {
  components: {
    VueSelect
  },
  props: {
    initialValue: {
      required: false
    },
    value: {
      required: true
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    placeholder: {
      type: String
    },
    name: {
      type: String,
      required: true
    },
    vValidate: {
      type: Function
    },
    hasErrors: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    reduce: {
      type: Function
    },
    change: {
      type: Function
    },
    disabled: {
      type: Boolean,
      default: false
    },
    getOptionLabel: {
      type: Function
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      internalValue: ''
    }
  },
  watch: {
    internalValue (newValue) {
      this.$emit('input', newValue)
      if (this.change) {
        this.change(newValue)
      }
    },
    value (newValue) {
      this.internalValue = newValue
    }
  },
  methods: {
    wrapperClass () {
      return (this.hasErrors) ? 'error' : ''
    }
  },
  mounted () {
    this.internalValue = this.initialValue
  }
}
</script>